/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
/*
 * Provides formatting methods for easier consolidation of data comming
 * from the 2 different serializers.
 * TODO semerdzhievp remove this service when
 * https://www.pivotaltracker.com/story/show/111714182 is resolved
 */
(function() {
   'use strict';
   angular.module('com.vmware.platform.ui')
         .factory('gsonAdapterService', gsonAdapterService);

   gsonAdapterService.$inject = [];

   function gsonAdapterService() {

      return {
         normalizeToTimestamp: function(dateString) {
            if (typeof dateString === 'string') {
               return moment(dateString, 'YYYY-MM-DD HH:mm:ss.SSS Z').valueOf();
            }
            return dateString;
         }
      };
   }
})();